export const ANALYTICS_HIDDEN_PARAMETER_KEYS = [
  'user_email',
  'user_phone_number',
  'avatar',
  'promo_code',
  'booking_id',
  'booking_reference',
  'form_email',
  'user_id',
  'value',
  'transaction_id',
  'event_id',
  'id',
  'first_name',
  'last_name',
  'email',
  'phone',
  'name',
  'device_id',
  'anonymous_id',
  'coalesced_id',
  'fbp',
  'fbc',
  'uuid_c1',
  'input_value',
  'event_source_url',
  'href',
  'to',
  'path_name',
  'as_path',
  'public_message',
  'private_message',
  'dietary_requirements',
  'stripe_token',
] as const;
